module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0713.c836dbe4.jpg";